/**
 * Series observable.
 */
import Main from '../../types/enums/main';
import seriesRequest from './seriesRequest';
import { Observable } from 'rxjs';

/**
 * Waiting time for the series observable.
 */
const WAITING_TIME = 100;

/**
 * Series observable.
 * @param id - The id of the series.
 * @returns An observable that emits the series data.
 */
export default function seriesObservable(id: string) {
  return new Observable((subscriber) => {
    seriesRequest(id).then((data) => {
      setTimeout(() => {
        subscriber.next({ data, type: Main.RAILS });
        subscriber.complete();
      }, WAITING_TIME);
    });
  });
}
